module.exports = __webpack_public_path__ + "assets/img/2101591934007_.pic_hd.7bd63459.jpg";